import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'support-desk',
  templateUrl: './support-desk.component.html',
  styleUrls: ['./support-desk.component.css']
})
export class SupportDeskComponent implements OnInit {
  // public searchInput: any = new Subject<string>();
//  public supportDeskComponentsName = []
  constructor(
    public router: Router,
    public storage: StorageService,
    public api: ApiService
  ) { }
  componentsMenu: any = [];
  searchedValue: any;

  // supportDeskComponents(data){
  // this.supportDeskComponentsName.forEach(e => {
  //   this.componentsMenu.push(e.name)
  //  });
  //  console.log(this.componentsMenu)

  //  if(this.componentsMenu.includes(data.name)){
  //    let name = data.name.toLowerCase()
  //    console.log([`/organization/transport-manager/support-desk/view-`+ `${name}`])

  //   this.router.navigate([`/organization/transport-manager/support-desk/view-`+`${name}`])
  //  }
  // }

  public availableModules = [
    {
      name: 'Announcement',
      img: 'annoncement.png',
      path: '/organization/transport-manager/support-desk/announcement/add-announcement'
    },
    {
      name: 'Complaints',
      img: 'compliant.png',
      path: '/organization/transport-manager/support-desk/complaint'
    }, {
      name: 'Feedback',
      img: 'feedback.png',
      path: '/organization/transport-manager/support-desk/feedback'
    }, {
      name: 'Ticket',
      img: 'ticket.png',
      path: '/organization/transport-manager/support-desk/ticket/view-ticket'
    },
  ];
  public supportDeskComponentsName:any=[];
  public userRestrictionData:any={};
  public userInfo:any={};

  ngOnInit(): void {
    this.userInfo = this.storage.get('userInfo');
    const obj = {
      orgID: this.userInfo.orgID
    };
    this.api.org_settingsList(obj).then((res: any) => {
        let mail=this.userInfo.userEmail;
        let selectedUser=res.data['userInfo'].filter(e=> e.userEmail==mail);
        this.userInfo['fieldMap']=selectedUser[0]['fieldMap'];
        this.storage.setData({ userInfo: this.userInfo });
        let user = this.userInfo;
        if(user && user['fieldMap']){
          this.userRestrictionData=user['fieldMap'];
          let subModulesOfSupportDesk=Object.keys(this.userRestrictionData['Support Desk'].menu1);
          for(let i=0;i<subModulesOfSupportDesk.length;i++){
            if(this.userRestrictionData && (this.userRestrictionData['Support Desk'].checked || this.userRestrictionData['Support Desk'].indeterminate) && this.userRestrictionData['Support Desk'].menu1 && this.userRestrictionData['Support Desk'].menu1[subModulesOfSupportDesk[i]] && (this.userRestrictionData['Support Desk'].menu1[subModulesOfSupportDesk[i]].checked || this.userRestrictionData['Support Desk'].menu1[subModulesOfSupportDesk[i]].indeterminate)){
              for(let j=0;j<this.availableModules.length;j++){
                if(subModulesOfSupportDesk[i]==this.availableModules[j].name){
                  this.supportDeskComponentsName.push(this.availableModules[j]);
                }
              }
            }
          }
        }
    }).catch((err) => {
        console.log(err);
    });
  }
}
